module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "list "
    }, [_c('div', {
      staticClass: "box flex vux-1px-b"
    }, [_c('router-link', {
      staticClass: "head-img",
      attrs: {
        "tag": "div",
        "to": {
          name: 'takeWineDetail',
          params: {
            id: item.rob_id
          }
        }
      }
    }, [_c('img', {
      staticClass: "img-block",
      attrs: {
        "src": item.image_default_id,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text flex flex-1 text-l"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "public-red text-r"
    }, [_vm._v(_vm._s(_vm._f("status")(item.STATUS)))]), _vm._v(" "), _c('div', {
      staticClass: "flex join"
    }, [_c('div', [_vm._v("\n                        参与"), _c('span', {
      staticClass: "public-red"
    }, [_vm._v(_vm._s(item.buy_num))]), _vm._v("份\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "public-gray",
      on: {
        "click": function($event) {
          _vm.lookNumber(item)
        }
      }
    }, [_vm._v("查看夺宝号")])])])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isTrue),
        expression: "item.isTrue"
      }],
      staticClass: "text-l flex number vux-1px-b"
    }, [_c('span', {}), _vm._v(" "), _c('span', {
      staticClass: "public-red"
    }, [_vm._v(_vm._s(item.numbers))])]), _vm._v(" "), (item.final_number) ? _c('div', {
      staticClass: "flex first-person vux-1px-b "
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "img-block",
      attrs: {
        "src": item.final_number_info.user_info.headimgurl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-l public-gray flex-1"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("获奖者 " + _vm._s(item.final_number_info.user_info.name))]), _vm._v(" "), _c('div', [_vm._v("参与份数 "), _c('span', {
      staticClass: "public-red"
    }, [_vm._v(_vm._s(item.final_number_info.buy_number))]), _vm._v("份")]), _vm._v(" "), _c('div', [_vm._v("幸运号码 " + _vm._s(item.final_number_info.final_number) + " "), _c('router-link', {
      staticClass: "fr methods",
      attrs: {
        "to": {
          name: 'formula',
          params: {
            rob_id: item.rob_id
          }
        },
        "tag": "span"
      }
    }, [_vm._v("计算公式")])], 1), _vm._v(" "), _c('div', [_vm._v("揭晓时间 " + _vm._s(_vm._f("timerForm")(item.final_number_info.final_time)))])])]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2109f26b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/takeWine/list.vue
// module id = 529
// module chunks = 0